// extracted by mini-css-extract-plugin
export default {"list":"family-select-row_list__8PPwQ","statusIcon":"family-select-row_statusIcon__Mylw0"};